import React from 'react'

interface LinkIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const LinkIcon: React.FC<LinkIconProps> = ({
  color = '#666',
  gradient,
  width = 23,
  height = 23,
  alt = 'Library icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 23 23'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M9.223 6.292a5.293 5.293 0 0 0 0 7.485l.884-.884a4.04 4.04 0 0 1 0-5.717l4.126-4.126a4.042 4.042 0 1 1 5.717 5.717l-3.3 3.3a.625.625 0 1 0 .883.884l3.3-3.3a5.292 5.292 0 1 0-7.484-7.485zm3.937 10.857a5.293 5.293 0 0 0 0-7.485l-.883.884a4.043 4.043 0 0 1 0 5.717L8.15 20.39a4.042 4.042 0 1 1-5.717-5.717l3.3-3.3a.625.625 0 0 0-.883-.884l-3.3 3.3a5.293 5.293 0 0 0 7.484 7.485z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default LinkIcon
